import Vue from 'vue';
import * as creatorsApi from '@/api/artist/creators.js';

const state = {
  // from query string in url (camelCase)
  query: {
  },
  filters: {
  },
  querys: {
    q: '',
    sort: '',
    page: 1,
    per_page: 50,
    role: '',
  },
  filtersList: [
    'role',
    'per_page',
  ],

  creators: [],

  pagination: {
    totalCount: 0,
    currentPage: 1,
    perPage: 10,
  },
};

function updateRow(state, updateRow) {
  if (!updateRow.id) return;

  if (state.creators && state.creators.length) {
    const index = state.creators.findIndex(x => x.id === updateRow.id);
    Vue.set(state.creators, index, { ...state.creators[index], ...updateRow });
  }
}

const getters = {
  // querys: state => state.querys,
  keyword: state => _.get(state.query, 'q'),

  filtersList: state => state.filtersList,
  hasSelectedFilters: state => _.size(_.omitBy(state.filters, _.isNil)) > 0,

  perPage: state => state.pagination.perPage,
  currentPage: state => state.pagination.currentPage,
  totalCount: state => state.pagination.totalCount,
};

const actions = {
  listCreators({ commit }, params) {
    commit('setCreators', []);

    return creatorsApi.listCreators(params)
      .then((response) => {
        console.log('listCreators', response);

        commit('setCreators', response.data.data);
        commit('setPagination', response.data);

        return response;
      });
  },

  deleteCreator({ commit }, id) {
    console.log('deleteCreator action', id);
    if (!id) return;

    // optimistically remove it from list
    commit('setCreators', state.creators.filter(x => !id.includes(x.id)));

    return creatorsApi.deleteCreator(id)
      .then((response) => {
        console.log('deleteCreator deleted', response);

        // if (response.status === 204) {
        //   // remove skus from list
        // }

        return response;
      });
  },


  // eslint-disable-next-line no-unused-vars
  updateCreator({ commit }, updateInfo) {
    console.log('updateCreator action', updateInfo);
    if (!updateInfo.id) return;

    return creatorsApi.updateCreator(updateInfo.id, updateInfo.data)
      .then((response) => {
        console.log('updateCreator done', response);

        if (response.status === 200) {
          const info = response.data.data;
          console.log('updateCreator return', info);
          updateRow(state, info);
        }

        return response;
      });
  },

  // eslint-disable-next-line no-unused-vars
  createCreator({ state, commit }, updateInfo) {
    console.log('createCreator action', updateInfo);
    if (!updateInfo.data) return;

    return creatorsApi.createCreator(updateInfo.data)
      .then((response) => {
        console.log('createCreator done', response);

        if (response.status === 201) {
          const info = response.data.data;
          // console.log('createCreator return', info);
          commit('setCreators', [info, ...state.creators]);
        }

        return response;
      });
  },

  // setSelectedIds({ commit }, ids) {
  //   commit('setSelectedIds', ids);
  // },

  setCurrentPage({ commit }, number) {
    commit('setCurrentPage', number);
  },

  setQuery({ commit }, query) {
    const filters = {};

    if (query.role) {
      filters.role = query.role;
    }

    commit('setFilters', filters);
    commit('setQuery', query);
  },

  setFilters({ commit }, filters) {
    commit('setFilters', filters);
  },
};

const mutations = {
  // setSelectedIds(state, ids) {
  //   console.log('setSelectedIds', ids, ids.length);
  //   state.selectedElementIds = ids || [];
  // },

  setQuery(state, query) {
    console.log('setQuery', query);
    state.query = query;
  },

  setFilters(state, filters) {
    state.filters = filters;
  },

  setCreators(state, data) {
    state.creators = data;
  },

  // pagination
  setCurrentPage(state, number) {
    state.pagination.currentPage = parseInt(number, 10);
  },

  setPerPage(state, number) {
    state.pagination.perPage = parseInt(number, 10);
  },

  setPagination(state, data) {
    state.pagination.currentPage = data.page;
    state.pagination.perPage = data.perPage;
    state.pagination.itemPerPage = data.perPage;
    state.pagination.totalCount = data.totalCount;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
